<app-drop-list
    class="drop-list"
    [items]="items"
    [maxItems]="1"
    (itemsChange)="reset()"
>
    <div *appDraggables="let item of items" class="option">
        <div class="option__wrapper">
            <span
                class="option__content"
                appScaleApply
                [innerHTML]="item.value | sanitizeHtml"
            ></span>
        </div>
        @if (checked) {
        <app-state-icon
            [state]="stateIcon"
            class="option__checked"
        ></app-state-icon>
        }
    </div>
</app-drop-list>
<div originalContent>
    <ng-content></ng-content>
</div>
